import {Component, OnInit, Renderer2} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {AppService} from "@services/app.service";
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {Subject, takeUntil} from 'rxjs';
import {UserDetails} from "@/model/user-details/UserDetails";
import SwiperCore, {Navigation, Pagination, SwiperOptions, Scrollbar} from 'swiper';
import {ImageDetails} from "@/model/asset-details/ImageDetails";
import {TraderImageDetails} from "@/model/asset-details/TraderImageDetails";
import {ConfigService} from "@/config.service";
import {tap} from "rxjs/operators";
import {ProductDetails} from "@/model/product/ProductDetails";
import {PostDetails} from "@/model/post/PostDetails";
import {LoggingService} from "@services/logging.service";
import {environment} from "../../../environments/environment";
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {BusinessDetails} from "@/model/business/BusinessDetails";
import {FarmerDetails} from "@/model/farmers/farmer-details";
import {UserService} from "@services/user.service";

SwiperCore.use([Navigation, Pagination, Scrollbar]);

@Component({
    selector: 'app-verify-profile',
    templateUrl: './verify-profile.component.html',
    styleUrls: ['./verify-profile.component.scss']
})

export class VerifyProfileComponent implements OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();
    userID: number;
    userDetailsById: UserDetails | undefined;
    userProductsList: ProductDetails[] = [];
    userPostList: PostDetails[] = [];
    regId: number;
    name: string;
    phoneNo: string;
    whatsAppNo: string;
    emailId: string;
    description: string;
    companyName: string;
    aboutBusiness: string;
    registeredAddress: string;
    displayAddress: string;
    paymentStatus: string;
    isTrader: string;
    isActive: string;
    accountStatus: string;
    verificationImageList: ImageDetails[] = [];
    traderImageList: TraderImageDetails[] = [];
    businessInformationList: BusinessDetails[] = [];
    farmDetailsList: FarmerDetails [] = [];
    endPoint: string;
    traderDetail: boolean = false;
    isLocalhost = window.location.hostname === 'localhost';
    isErrorShow: string;
    selectedImageUrl: string;
    imageModalShow = false;
    editModalShow: boolean = false;
    isWithoutSubscription: boolean = false;
    isShowSubscription: boolean = false;
    subscriptionType: string = "";
    subscriptionEndDate: number = 0;
    isApproveButtonShow: boolean = false;

    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private configService: ConfigService,
        private loggingService: LoggingService,
        private userService: UserService,
    ) {
    }

    userFormGroup = new UntypedFormGroup({
        userRegistrationId: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        name: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        phoneNumber: new UntypedFormControl("", [Validators.required, Validators.nullValidator, Validators.pattern(/^\d{10}$/)]),
        email: new UntypedFormControl("", [Validators.required, Validators.nullValidator, Validators.email]),
        enrollmentType: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        accountStatus: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        selfDescription: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        createdBy: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        createdAt: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        updatedBy: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        updatedAt: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        whatsappNumber: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        userAddress: new UntypedFormArray([]),
    });


    createAddressFormGroup(address: any): UntypedFormGroup {
        return new UntypedFormGroup({
            addressId: new UntypedFormControl(address.addressId || 0),
            addressType: new UntypedFormControl(address.addressType || '', [Validators.required]),
            doorNo: new UntypedFormControl(address.doorNo || '', [Validators.required]),
            streetName: new UntypedFormControl(address.streetName || '', [Validators.required]),
            area: new UntypedFormControl(address.area || '', [Validators.required]),
            village: new UntypedFormControl(address.village || '', [Validators.required]),
            city: new UntypedFormControl(address.city || '', [Validators.required]),
            state: new UntypedFormControl(address.state || '', [Validators.required]),
            pinCode: new UntypedFormControl(address.pinCode || '', [Validators.required]),
            landmark: new UntypedFormControl(address.landmark || ''),
            userId: new UntypedFormControl(address.userId || ''),
        });
    }


    public userUpdateFormErrors = {
        name: '', phoneNumber: '', email: '',
    }

    userUpdateValidation() {
        this.userUpdateFormErrors.name = "";
        this.userUpdateFormErrors.phoneNumber = "";
        this.userUpdateFormErrors.email = "";

        let hasError = false;

        if (this.userFormGroup.get("name")?.invalid) {
            this.userUpdateFormErrors.name = "Name is required";
            hasError = true;
        }

        if (this.userFormGroup.get("phoneNumber")?.invalid) {
            if (this.userFormGroup.get("phoneNumber")?.errors?.['required']) {
                this.userUpdateFormErrors.phoneNumber = "Phone Number is required";
            } else if (this.userFormGroup.get("phoneNumber")?.errors?.['pattern']) {
                this.userUpdateFormErrors.phoneNumber = "Phone Number must be 10 digits";
            }
            hasError = true;
        }

        if (this.userFormGroup.get("email")?.invalid) {
            if (this.userFormGroup.get("email")?.errors?.['required']) {
                this.userUpdateFormErrors.email = "Email is required";
            } else if (this.userFormGroup.get("email")?.errors?.['email']) {
                this.userUpdateFormErrors.email = "Email ID is not valid, please enter valid email ID";
            }
            hasError = true;
        }

        if (!hasError) {
            console.log('update user details::', this.userFormGroup.value);
            this.updateProfileByAdmin();
        }
    }

    get userAddressArray(): UntypedFormArray {
        return this.userFormGroup.get('userAddress') as UntypedFormArray;
    }


    OnSubmit() {
        this.userUpdateValidation();
    }

    openModal(image: any) {
        console.log(image.imageId);
        this.selectedImageUrl = `${this.endPoint}/api/image-details/get/${image.imageId}`;
        this.imageModalShow = true;
    }

    ngOnInit() {
        this.getUserRegisterDetail();
        this.getUserDetailsList();
        this.endPoint = this.configService.getConfig().END_POINT;
    }

    ngOnDestroy() {
        localStorage.removeItem('userRegId');
    }

    // UserRegId Get User Registered Detail show
    getUserRegisterDetail() {
        this.spinner.show();
        this.userID =  Number(localStorage.getItem('userRegId'));
        if (this.userID === null) {
            this.toastr.error('User ID not found');
            return;
        }
        this.appService
            .getRegisteredDetailsById(this.userID)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                    this.spinner.hide();
                    this.userDetailsById = data;
                    if (!environment.production && this.isLocalhost) {
                        console.log("reg details::", this.userDetailsById);
                    }
                    this.regId = this.userDetailsById.userRegistrationId
                    this.name = this.userDetailsById.name;
                    this.phoneNo = this.userDetailsById.phoneNumber;
                    this.whatsAppNo = this.userDetailsById.whatsappNumber;
                    this.emailId = this.userDetailsById.email;
                    this.description = this.userDetailsById.selfDescription;
                    this.isTrader = this.userDetailsById.enrollmentType.toUpperCase();
                    this.isErrorShow = this.userDetailsById.enrollmentType;
                    this.verificationImageList = this.userDetailsById.verificationImageList;
                    this.isActive = this.userDetailsById.accountStatus;
                    this.accountStatus = this.userDetailsById.accountStatus;
                    this.farmDetailsList = this.userDetailsById.farmDetails;
                    this.businessInformationList = this.userDetailsById.businessInformation;
                    console.log('user business list::', this.businessInformationList);
                    if (this.userDetailsById.traderDetails != null) {
                        this.companyName = this.userDetailsById.traderDetails.companyName;
                        this.aboutBusiness = this.userDetailsById.traderDetails.aboutTheCompany;
                        this.displayAddress = this.userDetailsById.traderDetails.displayAddress;
                        this.registeredAddress = this.userDetailsById.traderDetails.regAddress;
                        this.traderImageList = this.userDetailsById.traderDetails.traderImageList;
                        this.traderDetail = true;
                    } else {
                        this.traderDetail = false;
                    }
                    if (this.userDetailsById.paymentDetails != null) {
                        for (let pay of this.userDetailsById.paymentDetails) {
                            this.paymentStatus = pay.paymentStatus;
                        }
                        if (!environment.production && this.isLocalhost) {
                            console.log('payment::', this.paymentStatus);
                        }
                    }
                },
                (error: any) => {
                    console.error("Error:", error);
                    this.spinner.hide();

                    const errorMessage = error?.error?.message || "Something went wrong, please try again";
                    this.toastr.error(errorMessage);
                })
    }


    formatAccountStatus(status: string): string {
        switch (status) {
            case 'InActive':
                return 'In Active';
            case 'Subscription End':
                return 'Subscription End';
            case 'No Subscription':
                return 'No Subscription';
            case 'Active':
                return 'Active';
            case 'Trial':
                return 'Trial';
            case 'Subscription Expired':
                return 'Subscription Expired';
            default:
                return 'Unknown Status';
        }
    }


    onSelectSubscription(event: Event, subscriptionType: string): void {
        const subscription = (event.target as HTMLInputElement).value;
        console.log(subscription)
        this.isWithoutSubscription = subscription === 'WITHOUT_SUBSCRIPTION';
        this.subscriptionType = subscription;
        console.log(`Selected Subscription Type: ${this.subscriptionType}`);
        if (this.subscriptionType == 'WITHOUT_SUBSCRIPTION' && this.subscriptionEndDate != 0) {
            this.isApproveButtonShow = true;
        } else if (this.subscriptionType == 'WITH_SUBSCRIPTION') {
            this.isApproveButtonShow = true;
        }
    }

    onSelectSubscriptionEndDate(event: Event): void {
        const endSubscriptionDate = (event.target as HTMLInputElement).value;
        if (endSubscriptionDate) {
            const endSubscriptionEpochInSeconds = Math.floor(new Date(endSubscriptionDate).getTime());
            this.subscriptionEndDate = endSubscriptionEpochInSeconds;
            console.log(`Selected Date: ${endSubscriptionDate}`);
            console.log(`Epoch Timestamp: ${endSubscriptionEpochInSeconds}`);
            if (this.subscriptionType && this.subscriptionEndDate != 0) {
                this.isApproveButtonShow = true;
            }
        } else {
        }
    }


    // User Reg Id based User Verification Status update Functionality
    approveStatus(verificationStatus: string, regId: number) {
        const updateVerify: any = {
            verificationStatus,
            registrationId: regId,
            ...(verificationStatus === 'VERIFIED' && {
                subscriptionType: this.subscriptionType,
                ...(this.subscriptionType === 'WITHOUT_SUBSCRIPTION' && {
                    subscriptionEndDate: this.subscriptionEndDate,
                }),
            }),
        };

        console.log(updateVerify);
        this.appService
            .updateVerificationStatus(updateVerify)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                    this.spinner.hide();
                    if (!environment.production && this.isLocalhost) {
                        console.log("update Status::", data);
                    }
                    this.toastr.success('Verification status updated');
                    this.userDetailsById.accountStatus = data.accountStatus;
                    this.getUserRegisterDetail();
                },
                (error: any) => {
                    console.error("Error:", error);
                    this.spinner.hide();

                    const errorMessage = error?.error?.message || "Something went wrong, please try again";
                    this.toastr.error(errorMessage);
                });
    }


    // User ID based Products List show functionality
    getUserDetailsList() {
        this.appService.getUserIdBasedDetails(this.userID)
            .pipe((takeUntil(this.destroy$)),
                tap((userListData) => {
                    this.userProductsList = userListData.listOfProducts.sort();
                    this.userProductsList.sort((a, b) => b.productId - a.productId);
                    this.userPostList = userListData.listOfPosts;
                    if (!environment.production && this.isLocalhost) {
                        console.log('User Products::', this.userProductsList);
                        console.log('User Posts::', this.userPostList);
                    }
                    this.userPostList?.sort((a, b) => b.postId - a.postId);
                })
            )
            .subscribe((userDetails) => {
                    if (!environment.production && this.isLocalhost) {
                        console.log('user list::', userDetails)
                    }
                },
                (error: any) => {
                    console.error("Error:", error);
                    this.spinner.hide();

                    const errorMessage = error?.error?.message || "Something went wrong, please try again";
                    if (this.isErrorShow == 'Farmers' || this.isErrorShow == 'Agri Input'
                        || this.isErrorShow == 'FPO' || this.isErrorShow == 'Food Processors') {
                        console.log(this.isErrorShow)
                        this.toastr.error(errorMessage);
                    }
                })
    }

    //Edit user details
    editUserProfileDetails() {
        this.editModalShow = true;
        this.userFormGroup.controls['name'].setValue(this.name);
        this.userFormGroup.controls['phoneNumber'].setValue(this.phoneNo);
        this.userFormGroup.controls['whatsappNumber'].setValue(this.whatsAppNo);
        this.userFormGroup.controls['email'].setValue(this.emailId);
        this.userFormGroup.controls['selfDescription'].setValue(this.description);
        this.userFormGroup.controls['userRegistrationId'].setValue(this.userID);
        const userAddressArray = this.userFormGroup.controls['userAddress'] as UntypedFormArray;
        userAddressArray.clear(); // Clear previous address data

        // Populate addresses
        this.userDetailsById.userAddress.forEach((address: any) => {
            userAddressArray.push(this.createAddressFormGroup(address));
        });
    }

    editFarmsDetails(regId: number, userId: number, userType: string) {
        localStorage.setItem('farmsId', String(userId));
        localStorage.setItem('userGetType', userType);
        localStorage.setItem('vendorRegId', String(regId));
        this.router.navigate(['/main/business-details']);
    }

    editBusinessDetails(regId: number, userId: number, userType: string) {
        localStorage.setItem('businessId', String(userId));
        localStorage.setItem('userGetType', userType);
        localStorage.setItem('vendorRegId', String(regId));
        this.router.navigate(['/main/business-details']);
    }


    updateProfileByAdmin() {
        this.spinner.show();
        this.appService.updateProfile(this.userFormGroup.value)
            .pipe(takeUntil(this.destroy$))
            .subscribe((updateProfile) => {
                this.spinner.hide();
                this.editModalShow = false;
                console.log('update user details::', updateProfile);
                this.toastr.success("Profile updated successfully!");
                this.userDetailsById = updateProfile;
            }, (error: any) => {
                console.error("Error:", error);
                this.spinner.hide();
                const errorMessage = error?.error?.message || "Something went wrong, please try again";
                this.toastr.error(errorMessage);
            });
    }
}